
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import logo from '../../assets/images/logo.png';

export default function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="bg-gradient-to-b from-gray-900 to-gray-800 text-white">
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div>
            <img
              src={logo}
              alt="Dynamix Logo"
              className="h-10 w-auto mb-6 brightness-0 invert"
            />
            <p className="text-gray-300 text-sm leading-relaxed mb-4">
              {t('footerDescription', { ns: 'common' })}
            </p>
            <div className="flex gap-3">
              <a
                href="https://instagram.com/dynamixsteelfiber"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-gradient-to-br from-pink-500 via-purple-500 to-orange-400 hover:scale-110 rounded-full transition-all duration-300 cursor-pointer shadow-lg hover:shadow-pink-500/50"
              >
                <i className="ri-instagram-line text-lg text-white"></i>
              </a>
              <a
                href="https://wa.me/905300959741"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-gradient-to-br from-green-500 to-emerald-500 hover:scale-110 rounded-full transition-all duration-300 cursor-pointer shadow-lg hover:shadow-green-500/50"
              >
                <i className="ri-whatsapp-line text-lg text-white"></i>
              </a>
              <a
                href="mailto:info@dynamixsteelfiber.com"
                className="w-10 h-10 flex items-center justify-center bg-gradient-to-br from-blue-500 to-indigo-500 hover:scale-110 rounded-full transition-all duration-300 cursor-pointer shadow-lg hover:shadow-blue-500/50"
              >
                <i className="ri-mail-line text-lg text-white"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-4" style={{ fontFamily: 'Orbitron, sans-serif' }}>
              {t('quickLinks', { ns: 'common' })}
            </h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-300 hover:text-cyan-400 transition-colors text-sm cursor-pointer">
                  {t('home', { ns: 'common' })}
                </Link>
              </li>
              <li>
                <Link to="/product" className="text-gray-300 hover:text-cyan-400 transition-colors text-sm cursor-pointer">
                  {t('product', { ns: 'common' })}
                </Link>
              </li>
              <li>
                <Link to="/applications" className="text-gray-300 hover:text-cyan-400 transition-colors text-sm cursor-pointer">
                  {t('applications', { ns: 'common' })}
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-300 hover:text-cyan-400 transition-colors text-sm cursor-pointer">
                  {t('aboutUs', { ns: 'common' })}
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-cyan-400 transition-colors text-sm cursor-pointer">
                  {t('contact', { ns: 'common' })}
                </Link>
              </li>
            </ul>
          </div>

          {/* Products */}
          <div>
            <h3 className="text-lg font-bold mb-4" style={{ fontFamily: 'Orbitron, sans-serif' }}>
              {t('ourProduct', { ns: 'common' })}
            </h3>
            <ul className="space-y-2">
              <li>
                <Link to="/product" className="text-gray-300 hover:text-cyan-400 transition-colors text-sm cursor-pointer">
                  {t('hookedEndSteelFibers', { ns: 'common' })}
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold mb-4" style={{ fontFamily: 'Orbitron, sans-serif' }}>
              {t('contactUs', { ns: 'common' })}
            </h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-line text-cyan-400 text-lg flex-shrink-0 mt-1"></i>
                <span className="text-gray-300 text-sm">
                  Şeyh Sinan, Hüsmen Kalfa Sk. No:5/33, 59850 Çorlu/Tekirdağ
                </span>
              </li>
              <li className="flex items-center gap-3">
                <i className="ri-phone-line text-cyan-400 text-lg"></i>
                <a href="tel:+905300959741" className="text-gray-300 hover:text-cyan-400 transition-colors text-sm cursor-pointer">
                  +90 530 095 97 41
                </a>
              </li>
              <li className="flex items-center gap-3">
                <i className="ri-mail-line text-cyan-400 text-lg"></i>
                <a href="mailto:info@dynamixsteelfiber.com" className="text-gray-300 hover:text-cyan-400 transition-colors text-sm cursor-pointer">
                  info@dynamixsteelfiber.com
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-700">
        <div className="container mx-auto px-4 py-6">
          <div className="border-t border-white/20 pt-8 flex flex-col md:flex-row justify-center items-center gap-4">
            <p className="text-sm text-white/80">
              © {new Date().getFullYear()} Dynamix Steel Fiber. {t('allRightsReserved', { ns: 'common' })}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
